<template>
    <BaseModal :show="show">
        <ModalHeader
            :stepBtns="false"
            :closeBtn="false"
            title="Important!">
        </ModalHeader>
        <div class="modal-body">
            <p class="body-sm">This software provides mechanisms for viewing and editing the contents of certain pinball machine ROM images. <span class="highlight">It is up to you to determine if this software can be used without violating any agreements</span> that prohibits you from using this software. For example there may have been an agreement you agreed to when you obtained the ROM image. Additionally, you may be bound to an implicit agreement if your pinball machine came with a manual. The back cover of the manual may contain verbage that may make the use of this software a violation of the agreement.</p>
            <p class="body-sm">By clicking the 'I understand and agree' button below, you acknowledge that you have read the text in this dialog box and accept responsibility for using this software in an appropriate manner. You also recognize that <span class="highlight">modifying the contents of the ROM image can be potentially catastrophic</span> to your pinball machine. For example if you change a byte from a value of 5 to 200 and this byte in the ROM happened to be the number of milliseconds to energize a flasher, then this example ROM modification would cause the flasher bulb to burn out when the game tries to energize the flasher.</p>
            <p class="body-sm">Please do not distribute modified ROM images that may have been generated by this software or from any other source. This software is intended for personal use only and <span class="highlight">may not be used in a commercial environment</span>. Please click 'I do not agree' if you feel that using this software is legally, morally, or ethically wrong.</p>
            <p class="body-sm"><span class="highlight">The DMD images that this software extracts from the ROM is copyrighted material.</span> Please treat the images produced by this software as you would treat a photograph that belonged to somebody else. It is advised that you do not use any of the images on a web page, auction page, or any such public posting.</p>
            <p class="body-sm">Additionally some game ROMs contain private images of the designers loved ones and family members. Please respect the privacy of these individuals and do NOT reproduce, copy or otherwise make public such images.
            </p>
        </div>
        <ModalFooter>
            <div class="button-container">
                <StandardButton @click="this.$emit('agree');" size="small" class="agree-btn">I understand and agree</StandardButton>
                <StandardButton @click="this.$emit('disagree');" size="small">I do not agree</StandardButton>
            </div>
        </ModalFooter>
    </BaseModal>
</template>

<script>
import BaseModal from './BaseModal.vue';
import ModalHeader from './ModalHeader.vue';
import ModalFooter from './ModalFooter.vue';
import StandardButton from '../buttons/StandardButton.vue';


export default {
    name: 'SpriteModal',
    components: { 
        BaseModal,
        ModalHeader,
        ModalFooter,
        StandardButton
    },
    props: {
        show: Boolean
    }
}
</script>

<style scoped>
.modal-body p {
    margin-left: auto;
    margin-right: auto;
}
.button-container {
    display: flex;
    flex-direction: row;
    justify-content: center;
}
.highlight {
    color: var(--accent);
}
.agree-btn {
    margin-right: var(--space-md);
}

</style>